import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const QuestionIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 16 16"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8 2.66667C5.05448 2.66667 2.66667 5.05448 2.66667 8C2.66667 10.9455 5.05448 13.3333 8 13.3333C10.9455 13.3333 13.3333 10.9455 13.3333 8C13.3333 5.05448 10.9455 2.66667 8 2.66667ZM1.33333 8C1.33333 4.31811 4.31811 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.31811 14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.31811 14.6667 1.33333 11.6819 1.33333 8ZM8.16667 5.33333C7.52233 5.33333 7 5.85567 7 6.5C7 6.86819 6.70152 7.16667 6.33333 7.16667C5.96514 7.16667 5.66667 6.86819 5.66667 6.5C5.66667 5.11929 6.78595 4 8.16667 4C9.54738 4 10.6667 5.11929 10.6667 6.5C10.6667 7.47767 10.0867 8.31667 9.26 8.72833C9.00133 8.858 8.83333 9.12333 8.83333 9.41667V9.66667C8.83333 10.0349 8.53486 10.3333 8.16667 10.3333C7.79848 10.3333 7.5 10.0349 7.5 9.66667V9.41667C7.5 8.62233 7.95267 7.89567 8.66133 7.54133C9.00467 7.37 9.33333 6.97333 9.33333 6.5C9.33333 5.85567 8.811 5.33333 8.16667 5.33333ZM8 12C8.36819 12 8.66667 11.7015 8.66667 11.3333C8.66667 10.9651 8.36819 10.6667 8 10.6667C7.63181 10.6667 7.33333 10.9651 7.33333 11.3333C7.33333 11.7015 7.63181 12 8 12Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

QuestionIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(QuestionIcon);
